// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"7b37d095","133":"1c5b980d","361":"987c8d2b","527":"d1149076","787":"e8632896","815":"c73668fc","817":"21db25c2","849":"2ea374cb","911":"3cbc6e42"}[chunkId] + ".chunk.js";
};